import React from "react";

export default function TablePagination({ pagination, onPageChange }) {
  if (!pagination || pagination.total_pages <= 1) return null;

  return (
    <div className="flex justify-between items-center px-2 py-2 border-t">
      <span className="text-sm text-gray-500">
        Page {pagination.current_page} of {pagination.total_pages} ({pagination.total_count} total)
      </span>
      <div className="flex space-x-2">
        <button
          onClick={() => onPageChange(pagination.current_page - 1)}
          disabled={pagination.current_page <= 1}
          className="px-3 py-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
        >
          Previous
        </button>
        <button
          onClick={() => onPageChange(pagination.current_page + 1)}
          disabled={pagination.current_page >= pagination.total_pages}
          className="px-3 py-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
        >
          Next
        </button>
      </div>
    </div>
  );
}
